export const theme = {
  colors: {
    primary: "#006D5B",
    primaryLight: "#016D5B",
    secondary: "#373F51",
    white: "#FFFFFF",
    textColor: "#707070",
    lightGray: "#D0D0D0",
    lightGray2: "#F6F7FA",
    midGray: "#7F7F7F",
    tableHeader: "#f6f6f6",
    borderColor: "#D7D7D7",
    btnColor: "#EBEDED",
    regularText: "#2E2E2E",
    success: "#07BC0C",
    successLight: "#ECF5EA",
    danger: "#F23F3F",
    dangerLight: "#FFDAD7",
    body: "#F7FBFA",
    mobileBody: "#7070700F",
    iconColor: "#636363",
  },
  fonts: {
    body: "Montserrat",
    heading: "Montserrat",
  },
  breakpoints: {
    sm: 575,
    md: 767,
    lg: 991,
    xl: 1199,
    xxl: 1599,
  },
};
